import anime from 'animejs';
import BaseComponent from '../../js/base-component';
import checkResize from "../../js/is-mobile";

const ANIMATION_DURATION = 300;
const EASING = 'linear';

export default class Accordion extends BaseComponent {
    constructor(...args) {
        super(...args);
        this._isAnimating = false;

        this._justDesktop = this.element.classList.contains('just-mobile');

        this._justMobile = this.element.classList.contains('accordion--no-mobile');

        this._containFoucedElements = this.element.classList.contains('has-focused-elements');

        this._isMobile = checkResize.isMobile;
    }

    checkAccordion(){

        if (this.element.classList.contains('is-expanded') || (this._justDesktop && !checkResize.isMobile) || (this._justMobile && checkResize.isMobile)) {
            this._isExpanded = true;
        } else if (this.element.classList.contains('is-collapsed')) {
            this._isExpanded = false;
        } else {
            throw new Error('You have to specify one of accordion state: is-collapsed, is-expanded');
        }

        if(!this._justDesktop || this._justMobile || checkResize.isMobile) {
            this._onClickTrigger = this._onClickTrigger.bind(this);
            this._onKeydownTrigger = this._onKeydownTrigger.bind(this);
            this._onAnimationComplete = this._onAnimationComplete.bind(this);
        }

    }

    static getRequiredRefs() {
        return ['trigger', 'content'];
    }

    init() {
        this.checkAccordion();

        this._setAttributes();

        if(this._justDesktop) {
            this.addListener(window, 'resize', this._checkResize.bind(this));
        }

        if(!this._justDesktop || checkResize.isMobile) {
            this._addListeners();
        }

        if (this.element.classList.contains('header-accordion')) {
            document.addEventListener('click', e => this._clickOutsideAccordion(e));
        }
    }


    _clickOutsideAccordion(event) {
        let accordion = document.querySelector('[data-dc-component="accordion"]');

        if (!accordion.contains(event.target) && this._isExpanded) {
            this.collapse();
        }
    }

    _checkResize() {
        checkResize.check();
        if (!checkResize.isMobile && this._isMobile) {
            this._resetListeners();
            this._removeAttributes();
            this._isMobile = false;
        }
        else if (checkResize.isMobile && !this._isMobile) {
            this.init();
            this._setAttributes();
            this._isMobile = true;
        }
    }

    _addListeners() {
        this.refs.trigger.forEach((x) => {
            this.addListener(x, 'click', this._onClickTrigger);
            this.addListener(x, 'keydown', this._onKeydownTrigger);
        });
    }

    _resetListeners() {
        this.removeListeners();
        this.addListener(window, 'resize', this._checkResize.bind(this));
    }

    _setAttributes() {
        if(!this._justDesktop || checkResize.isMobile) {
            this.refs.trigger.forEach((x) => {
                x.setAttribute('aria-expanded', this._isExpanded);
            });
            this.refs.content.setAttribute('aria-hidden', !this._isExpanded);
        }
        if(this._containFoucedElements){
            this.refs.content.querySelectorAll('.is-focusable').forEach( input => {
                input.setAttribute('tabindex', this._isExpanded ? '0' : '-1');
            });
        }
    }

    _removeAttributes() {
        this.refs.trigger.forEach((x) => {
            x.removeAttribute('aria-expanded');
        });
        this.refs.content.removeAttribute('aria-hidden');

        if(this._containFoucedElements){
            this.refs.content.querySelectorAll('.is-focusable').forEach( input => {
                input.removeAttribute('tabindex');
            });
        }
    }

    _onClickTrigger(event) {
        if (typeof event !== 'undefined' &&
            typeof event.preventDefault === 'function'
        ) {
            event.preventDefault();
        }

        if (this._isAnimating) return;

        if (this._isExpanded) {
            this.collapse();
        } else {
            this.expand();
        }
    }

    _onKeydownTrigger(event) {
        const keyCode = event.which;

        switch (keyCode) {
            case 13:
            case 32:
                this._onClickTrigger(event);
                break;
            default:
                break;
        }
    }

    expand() {
        this._isAnimating = true;
        this.refs.content.style.display = 'block';
        this.refs.content.style.overflow = 'hidden';
        this.refs.content.style.maxHeight = '0';
        this.element.classList.remove('is-collapsed');
        this.element.classList.add('is-expanding');

        anime({
            targets: this.refs.content,
            maxHeight: [0, this.refs.content.scrollHeight],
            duration: ANIMATION_DURATION,
            easing: EASING,
            complete: () => {
                this._onAnimationComplete();
            }
        });
    }

    collapse() {
        this._isAnimating = true;
        // animejs do not set initial value for max height
        this.refs.content.style.maxHeight = `${this.refs.content.scrollHeight}px`;
        this.refs.content.style.overflow = 'hidden';
        this.element.classList.remove('is-expanded');
        this.element.classList.add('is-collapsing');

        anime({
            targets: this.refs.content,
            maxHeight: [this.refs.content.scrollHeight, 0],
            duration: ANIMATION_DURATION,
            easing: EASING,
            complete: () => {
                this._onAnimationComplete();
            }
        });
    }

    _onAnimationComplete() {
        this._isAnimating = false;
        this._isExpanded = !this._isExpanded;

        if (this._isExpanded) {
            this.element.classList.remove('is-expanding');
            this.element.classList.add('is-expanded');
        } else {
            this.element.classList.remove('is-collapsing');
            this.element.classList.add('is-collapsed');
        }

        this.refs.content.removeAttribute('style');
        this.refs.trigger.forEach((x) => {
            x.setAttribute('aria-expanded', this._isExpanded);
        });
        this.refs.content.setAttribute('aria-hidden', !this._isExpanded);

        if(this._containFoucedElements){
            this.refs.content.querySelectorAll('.is-focusable').forEach( input => {
                input.setAttribute('tabindex', this._isExpanded ? '0' : '-1');
            });
        }

    }
}
